export const PRODUCT_TYPE_OPTIONS = [
  { id: 0, name: "Trụ sở" },
  { id: 1, name: "Cơ sở" },
  { id: 2, name: "Tất cả" },
];

export const PRODUCT_TYPE_DETAIL_OPTIONS = [
  { id: 1, name: "Nhu yếu phẩm" },
  { id: 2, name: "Văn phòng phẩm" },
  { id: 3, name: "Giáo trình" },
  { id: 4, name: "Ấn phẩm" },
  { id: 5, name: "Chương trình khuyến mại" },
];

export const PRODUCT_STATUS_OPTIONS = [
  { value: 0, label: "Hiển thị" },
  { value: 1, label: "Ẩn" },
];

export const LOGISTICS_STATUSES = [
  "Chưa tiếp nhận",
  "Đang xử lý",
  "Đã cung cấp đủ hàng",
  "Đã nhận hàng",
  "Hoàn thành",
  "Hủy",
];

export const REQUEST_TYPES = [
  { id: 1, name: "Phòng ban" },
  { id: 2, name: "Cơ sở" },
];
